import React from 'react';
import { Content, Row, Col, Title, Text, Pagination, Button } from 'components';
import { SideMenu } from '../components';
import { DatePicker, Empty, Flex, Spin } from 'antd';
import { stringToMoneyFormat } from 'utils';
import MessageAlert from 'utils';
import dayjs from 'dayjs';
import Formatter from 'utils/Formatter';
import { encrypt } from 'utils/Crypto';

const PERIOD = [
  {
    label: '1개월',
    value: 1,
    key: 'month',
  },
  {
    label: '3개월',
    value: 3,
    key: 'month',
  },
  {
    label: '6개월',
    value: 6,
    key: 'month',
  },
  {
    label: '1년',
    value: 1,
    key: 'year',
  },
];

const DATE_FORMAT = 'YYYY/MM/DD';
const PAGE_COUNT = 5;
const PAGE_SIZE = 10;

const TAP = [
  {
    label: '전체',
    value: 'ALL',
  },
  {
    label: '충전',
    value: 'CHARGE',
  },
  {
    label: '사용',
    value: 'USE',
  },
  {
    label: '환불',
    value: 'REFUNDED-CANCELLED-DEDUCTED',
  },
];

const JM_TYPE = {
  AUTO_CHARGE: '자동 충전',
  REFUNDED: '페이 환불',
  USE: '주문 사용',
  CANCELLED: '충전 취소',
  MANUAL_CHARGE: '일반 충전',
  DEDUCTED: '페이 환불',
};

const MypagePayPresenter = (props) => {
  /* ===== Props ===== */
  const {
    user,
    selected,
    onSelect,
    isLoading,
    setIsLoading,
    history,
    onOpenPopup,
    screenSize,
    onCancelPay,
  } = props;

  /* ===== State ===== */
  // 내역
  const [paymentHistory, setPaymentHistory] = React.useState([]);
  // Period Range
  const [period, setPeriod] = React.useState([...selected]);
  const [currentPage, setCurrentPage] = React.useState(1); // 현재 페이지
  // Tap
  const [selectedTab, setSelectedTab] = React.useState('ALL');
  const [selectedDate, setSelectedDate] = React.useState('1개월');

  /* ===== Variables ===== */
  const styles = {
    buttonGroup: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    tabContainer: {
      display: 'flex',
      alignItems: 'center',
      borderBottom: '2px solid var(--black-color)',
    },
    tab: {
      width: screenSize >= 768 ? 160 : 130,
      height: screenSize >= 768 ? 66 : 55,
      lineHeight: screenSize >= 768 ? '66px' : '55px',
      textAlign: 'center',
      cursor: 'pointer',
      fontSize: screenSize >= 768 ? 16 : 14,
      border: '1px solid gray',
      backgroundColor: 'transparent',
      color: 'gray',
    },
    activeTab: {
      fontWeight: 'bold',
      backgroundColor: 'black',
      color: 'white',
      border: '2px solid black',
    },
    emptyState: {
      textAlign: 'center',
      padding: 20,
      fontSize: 16,
      color: 'gray',
    },
    button: {
      width: '25%',
      borderRadius: '0',
      border: '1px solid var(--light-gray-color)',
      backgroundColor: '#fff',
      color: 'var(--light-gray-color)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 700,
      fontSize: screenSize >= 768 ? 16 : 14,
      cursor: 'pointer',
    },
    activeButton: {
      border: '1px solid var(--black-color)',
      color: 'var(--black-color)',
    },
  };

  /* ===== Function ===== */
  /**
   * 페이징
   * --
   * @param {number} page
   */
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  /**
   *
   * @param {string} t
   * @param {number | dayjs} v1
   * @param {string | dayjs} v2
   */
  const handleRange = (t, v1, v2) => {
    const type = t.toLocaleUpperCase();

    switch (type) {
      case 'CLICK':
        const start = dayjs().subtract(v1, v2).startOf('day');
        setPeriod([start, dayjs().endOf('day')]);
        break;
      case 'SELECT':
        setPeriod([v1, v2]);
        break;
      default:
        break;
    }
  };

  /**
   * 기간 검색
   * --
   */
  const handlePeriodSearch = () => {
    const [start, end] = period;

    if (!start || !end) {
      return MessageAlert.info('검색 기간을 선택해주세요!');
    }

    onSelect(period);
  };

  /* ===== Hooks ===== */
  /**
   * 탭별 페이 목록 정제
   * --
   */
  React.useEffect(() => {
    setIsLoading(true);

    if (!history?.length) {
      setTimeout(() => {
        setPaymentHistory([]);
        setIsLoading(false);
      }, 500);

      return;
    }

    const splitTab = selectedTab.split('-');

    const filtered = history
      ?.filter((h) => (selectedTab === 'ALL' ? h : splitTab.includes(h.type)))
      ?.sort((a, b) => b.create_at - a.create_at);

    setTimeout(() => {
      setPaymentHistory(filtered);
      setIsLoading(false);
    }, 500);
    // eslint-disable-next-line
  }, [history, selectedTab]);

  /* ===== Render ===== */
  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content
          maxWidth={1820}
          padding={screenSize >= 768 ? '120px 0px 200px' : '60px 0'}
        >
          <Row gutter={25}>
            <Col x={0} md={1} xl={2}></Col>
            <Col x={0} md={6} xl={4}>
              <SideMenu />
            </Col>
            <Col x={24} md={16} xl={16}>
              <Content
                maxWidth={'100%'}
                padding={
                  screenSize >= 1200
                    ? '0 0 0 95px'
                    : screenSize >= 768
                    ? '0 0 0 20px'
                    : '0'
                }
              >
                {/* 포인트 내역 */}
                <Title
                  style={{
                    fontSize:
                      screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
                    fontWeight: 700,
                    marginBottom: 24,
                    fontFamily: 'Pretendard',
                  }}
                >
                  JM Pay 관리
                </Title>

                <Content
                  maxWidth={'100%'}
                  backgroundColor="#f4f4f4"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    height: screenSize >= 768 ? 164 : 'auto',
                    padding: 40,
                    marginBottom: 80,
                    borderRadius: 2,
                    flexDirection: screenSize >= 768 ? 'unset' : 'column',
                    gap: screenSize >= 768 ? 'unset' : '10px',
                  }}
                >
                  {/* 최상단 좌측 컨텐츠 시작 */}
                  <div
                    style={{
                      width: screenSize >= 768 ? '50%' : '100%',
                      borderRight:
                        screenSize >= 768
                          ? '1px solid var(--black-color)'
                          : 'none',
                      color: 'var(--white-color)',
                      borderBottom:
                        screenSize >= 768
                          ? 'none'
                          : '1px solid var(--black-color)',
                      paddingBottom: screenSize >= 768 ? 'none' : 20,
                      marginBottom: screenSize >= 768 ? 'none' : 20,
                    }}
                  >
                    <Text
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginRight: screenSize >= 768 ? 40 : '0',
                        size: 18,
                        height: '100%',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span>JM Pay</span>
                      <div
                        style={{
                          marginLeft: 'auto',
                          fontWeight: 700,
                          fontSize: 24,
                        }}
                      >
                        {stringToMoneyFormat(user?.jm_pay)}
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: 18,
                            marginLeft: 8,
                          }}
                        >
                          원
                        </span>
                      </div>
                    </Text>
                  </div>
                  {/* 최상단 좌측 컨텐츠 끝 */}

                  {/* 최상단 우측 컨텐츠 시작 */}
                  <div
                    style={{
                      width: screenSize >= 768 ? '50%' : '100%',
                      color: 'var(--white-color)',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Text
                      style={{
                        display: 'flex',
                        marginLeft: screenSize >= 768 ? 40 : 0,
                        size: 18,
                        height: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <span>JM Pay 충전</span>
                      <Button
                        style={{
                          borderRadius: '2px',
                        }}
                        onClick={() =>
                          onOpenPopup('charging', {
                            userId: encodeURIComponent(encrypt(user?.user_id)),
                          })
                        }
                      >
                        충전
                      </Button>
                    </Text>
                    {/* <Text
                      style={{
                        display: 'flex',
                        marginLeft: 40,
                        size: 18,
                        height: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <span>간편결제 카드 등록</span>
                      카드가 등록되고 나면 카드정보가 떠야함
                      <Button
                        style={{
                          borderRadius: '2px',
                        }}
                      >
                        등록
                      </Button>
                      카드가 등록되고 나면 변경버튼으로 변경돼야함
                    </Text> */}
                  </div>
                  {/* 최상단 우측 컨텐츠 끝 */}
                </Content>

                {/* 탭 메뉴 */}
                <div style={styles.tabContainer}>
                  {TAP.map((tap) => (
                    <div
                      key={tap.label}
                      style={{
                        ...styles.tab,
                        ...(selectedTab === tap.value ? styles.activeTab : {}),
                      }}
                      onClick={() => {
                        setSelectedTab(tap.value);
                        setCurrentPage(1); // 탭 변경 시 페이지를 초기화
                      }}
                    >
                      {tap.label}
                    </div>
                  ))}
                </div>

                {/* 개월 수 */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '32px 0',
                    borderBottom: '1px solid #ddd',
                    flexDirection: screenSize >= 768 ? 'unset' : 'column',
                    gap: screenSize >= 768 ? 'unset' : '10px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      width: screenSize >= 768 ? '51.44%' : '100%',
                      height: 48,
                    }}
                  >
                    <div style={styles.buttonGroup}>
                      {PERIOD.map((period) => (
                        <button
                          key={`${period.value}-${period.key}-${period.label}`}
                          style={{
                            ...styles.button,
                            ...(selectedDate === period.label
                              ? styles.activeButton
                              : {}),
                          }}
                          onClick={() => {
                            setSelectedDate(period.label);
                            handleRange('CLICK', period.value, period.key);
                            setCurrentPage(1); // 기간 변경 시 페이지를 초기화
                          }}
                        >
                          {period.label}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: screenSize >= 768 ? '46.3%' : '100%',
                    }}
                  >
                    <DatePicker.RangePicker
                      style={{
                        width: '64%',
                        height: 48,
                        border: '1px solid var(--light-gray-color)',
                      }}
                      value={period}
                      format={DATE_FORMAT}
                      placeholder={['시작일', '종료일']}
                      minDate={dayjs().subtract(365, 'day')}
                      maxDate={dayjs()}
                      onChange={([start, end]) =>
                        handleRange('SELECT', start, end)
                      }
                    />
                    <Button
                      style={{
                        width: '31.12%',
                        borderRadius: '0',
                        fontWeight: 700,
                        fontSize: screenSize >= 768 ? 16 : 14,
                        backgroundColor: 'var(--white-color)',
                        color: 'var(--black-color)',
                        border: '1px solid var(--black-color)',
                      }}
                      onClick={() => handlePeriodSearch()}
                    >
                      조회
                    </Button>
                  </div>
                </div>

                {/* 포인트 목록 */}
                <div>
                  {paymentHistory.length ? (
                    paymentHistory
                      ?.slice(
                        (currentPage - 1) * PAGE_SIZE,
                        currentPage * PAGE_SIZE
                      )
                      ?.map((_item, index) => (
                        <div
                          key={`jm-pay-${index}-${_item.jm_pay_id}`}
                          style={{
                            borderBottom: '1px solid #ddd',
                            padding: 10,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '32px 0',
                              width: '100%',
                              justifyContent: 'space-between',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                gap: screenSize >= 768 ? 0 : 20,
                              }}
                            >
                              <Text
                                size={16}
                                style={{
                                  width: screenSize >= 768 ? 124 : 'auto',
                                }}
                              >
                                {Formatter.unixToDate(
                                  _item?.created_at,
                                  'YYYY.MM.DD'
                                )}
                              </Text>
                              <Text
                                size={16}
                                style={{
                                  width: screenSize >= 768 ? 124 : 'auto',
                                }}
                              >
                                {JM_TYPE[_item?.type]}
                              </Text>
                            </div>

                            <Flex>
                              {_item.canRefund === 'Y' ? (
                                <Text
                                  size={16}
                                  color={
                                    _item.canRefund === 'Y' ? 'black' : 'gray'
                                  }
                                  style={{
                                    cursor:
                                      _item.canRefund === 'Y'
                                        ? 'pointer'
                                        : 'default',
                                    textDecoration:
                                      _item.canRefund === 'Y'
                                        ? 'underline'
                                        : 'none',
                                  }}
                                  onClick={() => onCancelPay(_item)}
                                >
                                  충전취소
                                </Text>
                              ) : null}
                              <Text
                                size={16}
                                weight={700}
                                color={'var(--red-secondary-color)'}
                                style={{
                                  minWidth: 100,
                                  textAlign: 'end',
                                }}
                              >
                                {_item?.price > 0 ? '+' : ''}
                                {stringToMoneyFormat(_item?.price)}원
                              </Text>
                            </Flex>
                          </div>
                        </div>
                      ))
                  ) : (
                    <div style={{ textAlign: 'center', padding: 20 }}>
                      <Empty description={'포인트 내역이 없습니다.'} />
                    </div>
                  )}
                </div>

                {/* 페이지네이션 */}
                <div style={{ marginTop: 100 }}>
                  <Pagination
                    total={paymentHistory?.length}
                    pageSize={PAGE_SIZE}
                    current={currentPage} // 상태 동기화
                    onChange={handlePageChange}
                    showSizeChanger
                    onShowSizeChange={(current, size) => {
                      setCurrentPage(1); // 페이지 크기 변경 시 페이지 초기화
                    }}
                    showPage={PAGE_COUNT}
                    buttonStyle={{
                      fontSize: 16,
                      fontWeight: 700,
                      color: '#999999',
                      background: 'none',
                      width: 28,
                      height: 28,
                    }}
                    isButton={true}
                    activeStyle={{
                      color: `var(--black-color) !important`,
                      borderBottom: '2px solid #111111',
                    }}
                    hoverStyle={{
                      color: `var(--black-color) !important`,
                    }}
                    navStyle={{
                      border: '1px solid var(--black-color)',
                    }}
                    isLatestButton={true}
                  />
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: 80,
                    padding: '16px 0',
                    color: 'var(--black-color)',
                    lineHeight: 1.75,
                  }}
                >
                  <span
                    style={{
                      marginBottom: 16,
                      fontWeight: 700,
                    }}
                  >
                    JM Pay 유의사항
                  </span>
                  <span>
                    ∙ 보유 충전 포인트 한도는 50만 포인트입니다. (한도 초과 시
                    충전이 불가하며, 잔여 포인트 소진 후 가능합니다.)
                  </span>
                  <span>
                    ∙ 충전 취소는 충전 이후 거래내역이 없는 경우에 한해, 충전
                    결제일로부 터 7일 이내에만 가능합니다. (포인트 &gt;
                    적립/사용내역 &gt; 취소할 결제 건의 '충전취소' 선택)
                  </span>
                  <span>
                    ∙ 환불은 최종 충전 후 잔액의 60% 이상이 사용된 경우에만
                    가능합니다.
                  </span>
                  <span>
                    ∙ 포인트 이관은 동일명의로 인증된 번호로만 가능합니다.
                    (명의가 다를 경우, 포인트 이관이 불가합니다.)
                  </span>
                  <span>
                    ∙ 충전한 포인트는 제이엠커피 모든 매장에서 현금과 동일하게
                    주문결제 시 사용 가능합니다.(현금영수증 발급)
                  </span>
                  <span>
                    ∙ 충전한 포인트의 유효기간은 충전일로부터 5년입니다.
                  </span>
                </div>
              </Content>
            </Col>
            <Col x={0} md={1} xl={2}></Col>
          </Row>
        </Content>
      </Spin>
    </React.Fragment>
  );
};

export default MypagePayPresenter;
